export const userSessionStats = `
query MyQuery($type: PeriodType = DAILY) {
  userSessionStats(type: $type) {
    count
    label
  }
}
`